
import Vue from "vue";
import {AuthService, MainSocketService, SaleService, UserConfigService} from "@/services";

export default Vue.extend({
	data(){
		return {
			displayID: "",
			link: "",
			key: 0
		};
	},
	methods: {
		async onDisplayReceived(id:number){
			this.link="";
			this.key=id;
			this.link = await SaleService.generatePublicUrl(id);
		},
		async onClearDisplay(){
			this.link="";
			this.key=0;
		}
	},
	async created() {
		let c = await UserConfigService.getCashierSettings();
		this.displayID = c.ConnectedDisplay;
		if(this.displayID && this.displayID!=""){
			MainSocketService.on(`/cashier/display/${AuthService.wfDossier.id}_${this.displayID}/open`, this.onDisplayReceived, this);
			MainSocketService.on(`/cashier/display/${AuthService.wfDossier.id}_${this.displayID}/clear`, this.onClearDisplay, this);
		}
	},
	beforeDestroy(): void {
		MainSocketService.offAll(this);
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.sales.CashierRefund"
	},
});
